import { createFileRoute, Link } from "@tanstack/react-router";
import { Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/features/auth/use-auth";

export const Route = createFileRoute("/403")({
	component: ForbiddenPage,
	validateSearch: (search: Record<string, unknown>) => ({
		element: typeof search.element === "string" ? search.element : undefined,
		from: typeof search.from === "string" ? search.from : undefined,
	}),
});

function ForbiddenPage() {
	const { element, from } = Route.useSearch();
	const { hasRole } = useAuth();
	const isSuperAdmin = hasRole("super_admin");

	return (
		<div className="flex min-h-screen items-center justify-center bg-background p-6 max-md:min-h-dvh max-md:items-start max-md:px-4">
			<div className="w-full max-w-md rounded-lg border border-border bg-card p-8 shadow-sm max-md:p-6">
				<div className="mb-4 flex size-12 items-center justify-center rounded-full bg-muted">
					<Lock className="size-6 text-muted-foreground" />
				</div>
				<h1 className="mb-2 text-2xl font-semibold text-foreground">Brak dostepu</h1>
				<p className="mb-6 text-sm text-muted-foreground">
					Nie masz uprawnien do tej strony. Skontaktuj sie z administratorem, jesli uwazasz, ze to
					pomylka.
				</p>
				{isSuperAdmin && (element || from) && (
					<div className="mb-6 rounded-md bg-muted p-3 text-xs text-muted-foreground max-md:break-all">
						<div className="font-semibold">Debug (super_admin only)</div>
						{element && (
							<div>
								element_id: <code className="font-mono">{element}</code>
							</div>
						)}
						{from && (
							<div>
								from: <code className="font-mono">{from}</code>
							</div>
						)}
					</div>
				)}
				<div className="flex gap-2">
					<Button asChild className="flex-1 max-md:h-11">
						<Link to="/dashboard">Wroc na pulpit</Link>
					</Button>
				</div>
			</div>
		</div>
	);
}
